export default class ParentIncome {

    constructor() {
        this.incomeTaxAssessment = 0;
        this.grossAnnualIncome = 0;
        this.incomeAgricultureForestryAndCommercial = 0;
        this.incomeCapitalAssets = 0;
        this.incomeRentalAndLeasing = 0;
        this.incomeTaxedDueToInsignificance = 0;
        this.pensions = 0;
        this.maintenanceServicesForCustodians = 0;
        this.childSupport = 0;
        this.incomeOthers = 0;
        this.unemploymentBenefit = 0;
        this.alg2 = 0;
        this.bafoeg = 0;
        this.asylumSeekerBenefits = 0;
        this.incomeOthersSgb = 0;
        this.benefitsParagraph32bEstG = 0;
        this.housingBenefit = 0;
        this.sicknessBenefit = 0;
        this.maternityBenefit = 0;
        this.parentalBenefit = 0;
        this.childBenefit = 0;
        this.otherServicesDueToSocialLaws = 0;
        this.incomeFromSelfEmploymentEstimated = 0;
        this.incomeFromSelfEmploymentAccordingToTaxAssessment = 0;
        this.incomeDecreaseByAlimonyPayments = 0;
        this.incomeDecreaseByAdvertisingCosts = 0;
        this.incomeDecreaseByAdvertisingCosts = 0;
        this.incomeDecreaseByIncomeTax = 0;
        this.incomeDecreaseBySolidaritySurcharge = 0;
        this.incomeDecreaseByChurchTax = 0;
        this.incomeDecreaseByEmployeeContributionPensionInsurance = 0;
        this.incomeDecreaseByEmployeeContributionHealthInsurance = 0;
        this.incomeDecreaseByEmployeeContributionNursingCareInsurance = 0;
        this.incomeDecreaseByEmployeeContributionUnemploymentInsurance = 0;
        this.incomeDecreaseByOther = 0;


    }

    sum() {
        let sum = this.incomeTaxAssessment
            + this.grossAnnualIncome
            + this.incomeAgricultureForestryAndCommercial
            + this.incomeCapitalAssets
            + this.incomeRentalAndLeasing
            + this.incomeTaxedDueToInsignificance
            + this.pensions
            + this.maintenanceServicesForCustodians
            + this.childSupport
            + this.incomeOthers
            + this.unemploymentBenefit
            + this.alg2
            + this.bafoeg
            + this.asylumSeekerBenefits
            + this.incomeOthersSgb
            + this.benefitsParagraph32bEstG
            + this.housingBenefit
            + this.sicknessBenefit
            + this.maternityBenefit
            + this.parentalBenefit
            + this.childBenefit
            + this.otherServicesDueToSocialLaws
            + this.incomeFromSelfEmploymentEstimated
            + this.incomeFromSelfEmploymentAccordingToTaxAssessment
            - this.incomeDecreaseByAlimonyPayments
            - this.incomeDecreaseByAdvertisingCosts
            - this.incomeDecreaseByIncomeTax
            - this.incomeDecreaseBySolidaritySurcharge
            - this.incomeDecreaseByChurchTax
            - this.incomeDecreaseByEmployeeContributionPensionInsurance
            - this.incomeDecreaseByEmployeeContributionHealthInsurance
            - this.incomeDecreaseByEmployeeContributionNursingCareInsurance
            - this.incomeDecreaseByEmployeeContributionUnemploymentInsurance
            - this.incomeDecreaseByOther;

        return isNaN(sum) ? 0 : sum / 100;
    }

    static fromData(data) {
        let parentIncome = new ParentIncome();
        if (data) {
            parentIncome.incomeTaxAssessment = data.incomeTaxAssessment;
            parentIncome.grossAnnualIncome = data.grossAnnualIncome;
            parentIncome.incomeAgricultureForestryAndCommercial = data.incomeAgricultureForestryAndCommercial;
            parentIncome.incomeCapitalAssets = data.incomeCapitalAssets;
            parentIncome.incomeRentalAndLeasing = data.incomeRentalAndLeasing;
            parentIncome.incomeTaxedDueToInsignificance = data.incomeTaxedDueToInsignificance;
            parentIncome.pensions = data.pensions;
            parentIncome.maintenanceServicesForCustodians = data.maintenanceServicesForCustodians;
            parentIncome.childSupport = data.childSupport;
            parentIncome.incomeOthers = data.incomeOthers;
            parentIncome.unemploymentBenefit = data.unemploymentBenefit;
            parentIncome.alg2 = data.alg2;
            parentIncome.bafoeg = data.bafoeg;
            parentIncome.asylumSeekerBenefits = data.asylumSeekerBenefits;
            parentIncome.incomeOthersSgb = data.incomeOthersSgb;
            parentIncome.benefitsParagraph32bEstG = data.benefitsParagraph32bEstG;
            parentIncome.housingBenefit = data.housingBenefit;
            parentIncome.sicknessBenefit = data.sicknessBenefit;
            parentIncome.maternityBenefit = data.maternityBenefit;
            parentIncome.parentalBenefit = data.parentalBenefit;
            parentIncome.childBenefit = data.childBenefit;
            parentIncome.otherServicesDueToSocialLaws = data.otherServicesDueToSocialLaws;
            parentIncome.incomeFromSelfEmploymentEstimated = data.incomeFromSelfEmploymentEstimated;
            parentIncome.incomeFromSelfEmploymentAccordingToTaxAssessment = data.incomeFromSelfEmploymentAccordingToTaxAssessment;
            parentIncome.incomeDecreaseByAlimonyPayments = data.incomeDecreaseByAlimonyPayments;
            parentIncome.incomeDecreaseByAdvertisingCosts = data.incomeDecreaseByAdvertisingCosts;
            parentIncome.incomeDecreaseByIncomeTax = data.incomeDecreaseByIncomeTax;
            parentIncome.incomeDecreaseBySolidaritySurcharge = data.incomeDecreaseBySolidaritySurcharge;
            parentIncome.incomeDecreaseByChurchTax = data.incomeDecreaseByChurchTax;
            parentIncome.incomeDecreaseByEmployeeContributionPensionInsurance = data.incomeDecreaseByEmployeeContributionPensionInsurance;
            parentIncome.incomeDecreaseByEmployeeContributionHealthInsurance = data.incomeDecreaseByEmployeeContributionHealthInsurance;
            parentIncome.incomeDecreaseByEmployeeContributionNursingCareInsurance = data.incomeDecreaseByEmployeeContributionNursingCareInsurance;
            parentIncome.incomeDecreaseByEmployeeContributionUnemploymentInsurance = data.incomeDecreaseByEmployeeContributionUnemploymentInsurance;
            parentIncome.incomeDecreaseByOther = data.incomeDecreaseByOther;

        }

        Object.seal(parentIncome);
        return parentIncome;
    }
}
